import type { BodyState } from "../physics/body";

type Quat = BodyState["quat"];

/** How far a block is turned about the vertical axis, in radians. */
export function yawOf(q: Quat): number {
  // Where the block's own x axis points, seen from above. A block stood on its
  // end points that axis up, so its z axis gives the turn instead
  const { x, y, z, w } = q;
  const xx = 1 - 2 * (y * y + z * z),
    xz = 2 * (x * z - w * y);
  if (Math.hypot(xx, xz) > 0.5) return Math.atan2(-xz, xx);
  const zx = 2 * (x * z + w * y),
    zz = 1 - 2 * (x * x + y * y);
  return Math.atan2(zx, zz);
}

const QUARTER = Math.PI / 2;

/**
 * The preview's turn, lined up with a block's edges: the block's own turn
 * plus however many quarter turns the preview had relative to it, so a plank
 * turned across stays across.
 */
export function alignYaw(previewYaw: number, blockYaw: number): number {
  return blockYaw + Math.round((previewYaw - blockYaw) / QUARTER) * QUARTER;
}
